import siteConfig from "../../../site.config.json";

// Runtime-neutral site constants: no import.meta, no process.env, so this
// module loads in Vite, Convex, and node bundles alike. Files shared with
// Convex (e.g. voicePresets) import from here; browser-only code imports
// ./site, which layers the VITE_* env overrides on top.
export const trimUrl = (u: string) => u.replace(/\/+$/, "");
export const joinUrl = (base: string, path = "") =>
  `${base}${path.startsWith("/") || path === "" ? path : `/${path}`}`;

export const SITE_NAME = siteConfig.name;
export const BASE_SITE_URL = trimUrl(siteConfig.siteUrl);
export const BASE_CDN_URL = trimUrl(siteConfig.cdnUrl);
